import { useTranslation } from "react-i18next";
import { useAppSelector } from "src/common/state/hooks";
import Navigation from "../../common/components/Navigation/Navigation";
import { getSelectedProjectGroup } from "../../features/projectGroups/state/projectGroupsSlice";
import CreateProjectGroupName from "./CreateProjectGroupName";

const EditProjectGroupNameWrapper = () => {
  const { t } = useTranslation();

  const selectedProjectGroup = useAppSelector(getSelectedProjectGroup);

  return (
    <>
      <Navigation
        title={
          <>
            <span style={{ color: "black" }}>{t("pages.editProjectGroupName.title")} :</span>
            {` ${selectedProjectGroup.name}`}
          </>
        }
        isProjectGroupView={true}
      />
      <CreateProjectGroupName mode="edit" />
    </>
  );
};

export default EditProjectGroupNameWrapper;
